import { pedir } from '@/lib/cliente';
import type {
  ArchivoBancoBNResultado,
  ArchivoBancoSemanaGuardado,
  ArchivoBancoSemanaResultado,
  ArchivoBancoSemanaVistaPrevia,
  RespuestaApi,
} from '@adelante/shared';

/** Archivo de banco BAC de Pagos Semanales (separado de `cliente` para no mezclar con las propuestas). */
export const clienteArchivoBancoSemana = {
  vistaPrevia: (semanaId: number, cuentaBancoOrigen: string) =>
    pedir<RespuestaApi<ArchivoBancoSemanaVistaPrevia>>(
      `/api/semanas/${semanaId}/archivo-banco-bac/vista-previa?${new URLSearchParams({ cuentaBancoOrigen })}`,
    ),
  generar: (
    semanaId: number,
    body: { cuentaBancoOrigen: string; planCode: string; envioNo: number; fecha: string },
  ) =>
    pedir<RespuestaApi<ArchivoBancoSemanaResultado>>(`/api/semanas/${semanaId}/archivo-banco-bac`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  /** .TRF y .SIN del Banco Nacional: no se guardan, se arman al momento. */
  generarBN: (
    semanaId: number,
    body: { cuentaBancoOrigen: string; transferenciaNo: number; fecha: string },
  ) =>
    pedir<RespuestaApi<ArchivoBancoBNResultado>>(`/api/semanas/${semanaId}/archivo-banco-bn`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  guardados: (semanaId: number) =>
    pedir<RespuestaApi<ArchivoBancoSemanaGuardado[]>>(
      `/api/semanas/${semanaId}/archivos-banco-bac`,
    ),
};
